<i18n src='@/locale/history-localization.json'></i18n>

<template>
    <v-autocomplete
        dense
        outlined
        v-model="select"
        @input="handleInput"
        :items="items"
        :search-input.sync="search"
        :item-text="displayName"
        :readonly="readonly"
        return-object
        :clearable="!readonly"
        no-filter
        flat
        hide-no-data
        hide-details
        :label="label || $t('History')"
    ></v-autocomplete>
</template>

<script>
import historyService from '@/service/history-service';

export default {
    props: {
        value: Number,
        label: String,
        readonly: Boolean,
        dispalyCode: Boolean,
    },
    data() {
        return {
            items: [],
            search: null,
            select: null,
            timer: null,
            getDataAbort: null,
        }
    },
    mounted() {
        if (this.value) {
            this.setSelected(this.value);
        }
    },
    watch: {
        search(value, oldValue) {
            if (value !== oldValue) {
                if (
                    value !== (this.select && this.select.code) &&
                    value !== this.displayName(this.select)
                ) {
                    clearTimeout(this.timer);
                    this.items = [];
                    if (this.getDataAbort) {
                        this.getDataAbort.abort();
                    }
                    if (value) {
                        this.timer = setTimeout(
                            () => this.querySelections(value),
                            300
                        );
                    }
                }
            }
        },
        value(val) {
            if (!val) {
                this.search = null;
                this.select = null;
                this.items = [];
            } else {
                this.setSelected(val);
            }
        },
    },
    methods: {
        async getData(filter, callback) {
            if (this.getDataAbort) {
                this.getDataAbort.abort();
                this.items = [];
            }
            this.getDataAbort = new AbortController();
            historyService
                .getSelectData(
                    1,
                    20,
                    filter,
                    this.getDataAbort && this.getDataAbort.signal
                )
                .then((response) => callback(response))
                .finally(() => {
                    this.getDataAbort = null;
                });
        },
        querySelections(search) {
            let filter = {};
            filter.search = search;
            this.getData(filter, (response) => (this.items = response.data));
        },
        handleInput() {
            this.$emit('input', this.select && this.select.code);
        },
        setSelected(value) {
            if (value && value !== (this.select && this.select.code)) {
                this.getData({ code: value }, (response) => {
                    var data = response.data.filter((d) => d.code == value);
                    if (data.length > 0) {
                        this.items = data;
                        this.select = data[0];
                    }
                });
            }
        },
        historyTypeDisplay(history) {
            if (history.history_type === 1) {
                return 'A';
            }
            return '';
        },
        displayName(history) {
            let result = null;
            if (history) {
                result = this.dispalyCode ? `[${history.code}] ` : '';
                result += `${
                    history.history_number || ''
                } ${this.historyTypeDisplay(history)} (${
                    history.patient_initials
                })`;
            }
            return result;
        },
    },
};
</script>

<style>
</style>